export default {
  "common": {
    "all": "Semua",
    "cancel": "Batal",
    "userAgreement": "Perjanjian Pengguna",
    "close": "Tutup",
    "submit": "Kirim",
    "submitting": "Mengirim...",
    "report": "Laporkan",
    "loading": "Memuat...",
    "noMore": "Tidak ada lagi",
    "search": "Cari",
    "today": "Hari Ini",
    "collapse": "Ciutkan",
    "retryLater": "Coba lagi nanti",
    "tips": "Tips",
    "friendlyReminder": "Tips Ramah",
    "finish": "Selesai",
    "noData": "Tidak ada data yang relevan",
    "retry": "Coba Lagi",
    "reset": "Atur ulang",
    "confirm": "Konfirmasi",
    "continue": "Lanjutkan",
    "notAvailableYet": "Belum tersedia"
  },
  "tab": {
    "home": "Beranda",
    "card": "Kartu",
    "mine": "Akun Saya"
  },
  "auth": {
    "loginTitle": "Dompet Web3 Pay",
    "loginSubtitle": "A single card connects assets and consumption, effortlessly unlocking a global payment experience",
    "createWallet": "Buat Wallet",
    "importWallet": "Dompet saya",
    "choiceOneWay": "Choose a method to quickly start your secure digital asset journey",
    "iHaveWallet": "Dompet saya",
    "choiceOneWay2": "Pilih satu metode login untuk memulai perjalanan aset digital Anda dengan aman",
    "createUseEmail": "Buat dengan Email",
    "createUseRemWord": "Buat Dompet Frasa Mnemonik",
    "loginUseEmail": "Masuk dengan Email",
    "loginByReWord": "Impor dengan Kunci Privat / Frasa Mnemonik",
    "validByEmail": "Verifikasi cepat lewat email, mudah dan praktis",
    "validByReWord": "Dikelola penuh oleh frasa mnemonik, aman dan terdesentralisasi",
    "validByReWord2": "Impor dengan frasa mnemonik/kunci privat/alamat dompet",
    "emailLoginRegister": "Email Login/Register",
    "inviteRegisterTitleStart": "Bayar sekali sentuh,",
    "inviteRegisterTitleEnd": "jadi mudah",
    "inviteRegisterStartRewards": "Buka Reward",
    "inviteRegisterWelcome": "Selamat datang di WinPay!",
    "agreePrefix": "By continuing to use, you agree to the WinPay Wallet's ",
    "privacyPolicy": "Privacy Policy",
    "and": "dan",
    "userAgreement": "Perjanjian Pengguna",
    "agreementMessage": "Please read the Privacy Policy and User Agreement first. Clicking 'Continue' indicates that you agree to the WinPay Wallet's Privacy Policy and User Agreement.",
    "agreementConfirm": "Saya telah membaca dan menyetujui",
    "addEmailAddress": "Tambah email",
    "inputEmailAddress": "Isi email",
    "emailAccountTip": "Email ini akan menjadi akun login Anda.",
    "emailAddress": "Alamat email",
    "email": "Email",
    "emailLogin": "Login Email",
    "enterEmail": "Isi email Anda",
    "enterEmailAddress": "Isi email",
    "register": "Daftar",
    "login": "Masuk",
    "enterVerificationCode": "Isi kode",
    "codeSentTo": "Kode dikirim ke ",
    "codeSentToEmail": "Kode verifikasi telah dikirim ke email Anda:",
    "codeValid": ", berlaku 10 menit.",
    "emailCode": "Kode email",
    "enterEmailCode": "Enter email code",
    "getCode": "Dapatkan kode",
    "resend": "Kirim Ulang",
    "codeSent": "Kode telah dikirim",
    "codeSentValid": "*Kode dikirim. Berlaku 10 menit",
    "cannotReceiveCode": "Tidak menerima kode?",
    "checkSpamFolder": "Periksa folder spam",
    "codeHelpTitle": "Tidak menerima kode verifikasi?",
    "codeHelpIntro": "Kode verifikasi biasanya terkirim dalam 1 menit. Jika Anda belum menerimanya:",
    "codeHelpEmailTitle": "Periksa apakah email sudah benar",
    "codeHelpEmailDesc": "Pastikan kode dikirim ke alamat email yang Anda harapkan. Kesalahan kecil dalam penulisan adalah alasan paling umum kode tidak terkirim.",
    "codeHelpSpamTitle": "Periksa folder spam",
    "codeHelpSpamDesc": "Email verifikasi terkadang ditandai sebagai spam. Tandai sebagai bukan spam agar kode berikutnya dapat masuk ke kotak masuk Anda.",
    "codeHelpResendTitle": "Ajukan kode verifikasi baru",
    "codeHelpResendDesc": "Pastikan menggunakan kode verifikasi terbaru karena kode lama akan kedaluwarsa.",
    "verify": "Verifikasi",
    "inputPassword": "Isi Kata Sandi",
    "setWalletPassword": "Atur Kata Sandi Dompet",
    "walletPasswordTip": "Set a password to manage your wallet. This password cannot be recovered. If you forget your password, you can go to my homepage - Security Settings - Retrieve Password, or log in again with your email and reset your payment password!",
    "setPasswordForTransaction": "Tetapkan kata sandi dompet untuk verifikasi.",
    "strongPassword": "Isi kata sandi yang kuat",
    "enterPasswordPlaceholder": "Silakan masukkan kata sandi",
    "enterPassword": "Isi",
    "confirmPassword": "Isi kata sandi lagi",
    "passwordTooShort": "*Password is too short. At least 8 characters.",
    "passwordWeak": "Kata sandi lemah",
    "passwordMedium": "Kata sandi sedang",
    "passwordStrong": "Kata sandi kuat",
    "passwordMismatch": "Kedua kata sandi tidak cocok",
    "passwordError": "Kesalahan kata sandi",
    "bindEmail": "Ikat email",
    "bindEmailIntro": "Untuk keamanan dana Anda, harap ikat email",
    "emailForRecovery": "Digunakan untuk memulihkan kata sandi",
    "emailRequired": "Email tidak boleh kosong",
    "codeRequired": "Kode tidak boleh kosong",
    "invitationCode": "Kode undangan",
    "enterInvitationCode": "Isi kode undangan (opsional)",
    "verificationFailed": "Verifikasi gagal",
    "walletReady": "Wallet ready",
    "walletCreatedSuccess": "Welcome Back!",
    "walletExploreTip": "WinPay full functionality enabled",
    "firstExploreCreateTitle": "Wallet created successfully!",
    "firstExploreRegisterTitle": "Login successful!",
    "firstExploreLoginTitle": "Welcome back!",
    "firstExploreImportTitle": "Wallet imported successfully!",
    "firstExploreCreateSubtitle": "You can now explore the public-chain crypto wallet",
    "firstExploreDefaultSubtitle": "WinPay full functionality enabled",
    "startExplore": "Mulailah menjelajah",
    "importTitle": "Isi frase mnemonic atau kunci pribadi",
    "importWalletTip": "Separate mnemonic words with spaces. Supports importing from any wallet.",
    "importPlaceholder": "Isi frase mnemonic atau kunci pribadi",
    "importInvalid": "Invalid input",
    "importTip1": "WinPay Wallet does not store your mnemonic or private key. You control your assets.",
    "importTip2": "Make sure no one else or camera can see your secret.",
    "importTip3": "Disarankan untuk memasukkan secara manual atau memindai untuk mengimpor frase mnemonic atau kunci pribadi Anda.",
    "continue": "Lanjutkan",
    "backupWarnTitle": "Harap Diingat Sebelum Mencadangkan!",
    "backupTipWrite": "Disarankan untuk Menulis Tangan",
    "backupTipNoCopy": "Jangan Menyalin dan Menyimpan",
    "backupTipNoScreenshot": "Jangan Mengambil Tangkapan Layar",
    "backupWarn1Title": "Frasa Mnemonik Sama dengan Kata Sandi Dompet Anda",
    "backupWarn1Desc": "Anyone with your mnemonic controls your assets. Leaks are irreversible.",
    "backupWarn2Title": "Harap Tulis Tangan atau Simpan di Dompet Dingin atau Perangkat Offline Lainnya",
    "backupWarn2Desc": "Jika Disalin atau Disimpan Sebagai Tangkapan Layar, Frasa Mnemonik Mungkin Bocor",
    "backupWarn3Title": "Simpan Frasa Mnemonik Anda di Tempat yang Aman",
    "backupWarn3Desc": "Setelah Hilang, Aset Tidak Dapat Dipulihkan",
    "backupWarnCheck": "You are responsible for your mnemonic. Back it up — loss means permanent asset loss.",
    "backupMnemonic": "Cadangkan Frasa Pemulihan",
    "mnemonicDesc": "Frasa pemulihan adalah kata sandi dompet Anda. Simpan dengan aman.",
    "verifyMnemonicTitle": "Verifikasi Frasa Pengingat",
    "verifyMnemonicTip": "Silakan Verifikasi Frasa Mnemonik Secara Berurutan",
    "ordinalNumber": "Word {number}",
    "mnemonicCheckFailed": "Verifikasi frasa pemulihan gagal",
    "mnemonicCheckSuccess": "Verifikasi frasa pemulihan berhasil",
    "mnemonicUnavailable": "No mnemonic backup available for this wallet",
    "verifyWalletPassword": "Enter payment password",
    "forgotPasswordRecovery": "Lupa kata sandi? Atur ulang",
    "resetPaymentPassword": "Pemulihan kata sandi",
    "resetPaymentPasswordTip": "Verify your bound email first, then reset the payment password",
    "changePassword": "Ubah kata sandi",
    "currentPassword": "Kata sandi saat ini",
    "enterCurrentPassword": "Isi kata sandi saat ini",
    "setPassword": "Atur kata sandi",
    "pleaseSetNewPasswordMin8": "Tetapkan kata sandi baru, minimal 8 karakter",
    "newPassword": "Kata sandi baru",
    "setNewPasswordMin8": "Set a new password with at least 8 characters",
    "enterNewPassword": "Isi kata sandi baru",
    "confirmNewPassword": "Konfirmasi kata sandi baru",
    "setNewPasswordAgain": "Konfirmasi ulang kata sandi baru yang telah ditetapkan",
    "currentPasswordIncorrect": "Kata sandi saat ini salah",
    "newPasswordSameAsOld": "Kata sandi baru tidak boleh sama dengan yang lama",
    "passwordsNotMatch": "Kata sandi baru tidak cocok",
    "passwordOnlySavedLocally1": "Saya memahami bahwa kata sandi hanya disimpan secara lokal di perangkat ini,",
    "passwordOnlySavedLocally2": "dan tidak dapat dipulihkan jika Anda lupa",
    "noBoundEmailRecover": "Anda belum mengikat email, tidak dapat memulihkan kata sandi",
    "goBindEmail": "Ikat email",
    "boundEmail": "Verifikasi email",
    "changeSuccess": "Perubahan berhasil",
    "bindEmailTip": "Silakan tautkan email terlebih dahulu sebelum memulihkan kata sandi",
    "bindEmailTip2": "Tautkan email sebelum memulihkan kata sandi untuk menerima kode verifikasi.",
    "bindEmailTip3": "Silakan ikat email Anda terlebih dahulu",
    "noBindEmail": "Tidak",
    "canUseWallet": "Selamat, Anda sekarang dapat menggunakan dompet!",
    "successfullyProtected": "Anda telah berhasil melindungi dompet Anda. Ingatlah untuk menjaga kata pemulihan dengan aman karena jika hilang, Anda tidak akan dapat memulihkannya! Anda dapat membuat cadangan kapan saja dengan masuk ke Pengaturan → Kelola Dompet → Pilih Dompet → Ekspor Kata Pemulihan.",
    "startUseApp": "Mulai Gunakan WinPay Wallet",
    "next": "Selanjutnya"
  },
  "home": {
    "title": "Beranda",
    "totalAssets": "Total aset",
    "receive": "Diterima",
    "scan": "Pindai",
    "transfer": "Transfer",
    "topup": "Isi Ulang",
    "withdraw": "Tarik",
    "bill": "Riwayat transaksi",
    "invite": "Undang",
    "invitCode": "Kode QR Kode undangan",
    "more": "Lebih",
    "recent": "Shortcuts",
    "community": "Komunitas",
    "token": "Token",
    "turnover": "Omset",
    "nft": "NFT",
    "accountAssets": "Akun",
    "cardAssets": "Kartu",
    "cardWallet": "Kartu",
    "backup": "Cadangkan Sekarang",
    "winpayCardPayment": "WinPay Virtual Card + Physical Card Dual Payment Support",
    "applyExclusiveCard": "Ajukan Kartu Eksklusif",
    "rwaChainTitle": "Rantai RWA Global",
    "rwaChainSubtitle": "Jelajahi aset nyata",
    "offRampTitle": "Off Ramp",
    "offRampSubtitle": "Tukar aset digital",
    "applyCardShortcutTitle": "Ajukan Kartu",
    "applyCardShortcutSubtitle": "Satu kartu, bayar global",
    "webxMerchant": "Webx Niaga",
    "socialFeature": "Sosial",
    "gamesFeature": "Game",
    "moviesFeature": "Film",
    "featureNoticeTitle": "Pratinjau Fitur",
    "offRampNoticeTitle": "Off Ramp segera hadir",
    "offRampNoticeDesc": "Nikmati pengalaman keluar-masuk dana yang lebih praktis dan efisien!",
    "offRampNoticeConfirm": "Mengerti",
    "nodeFast": "Node OK",
    "nodeSlow": "Node Slow",
    "nodeBad": "Node Error",
    "node": "Node",
    "viewAccount": "Pilih Akun",
    "selectAccount": "Pilih Akun",
    "selectNode": "Pilih node",
    "blockHeightExplain": "Lower latency and newer block height usually mean a better node connection.",
    "recommendNode": "Simpul yang Direkomendasikan",
    "blockHeight": "Tinggi Blok",
    "currentAccountNotSupport": "The current account does not support this network.",
    "noData": "Tidak ada data",
    "actionTodo": "Belum tersedia",
    "cardTailNo": "Empat Digit Terakhir",
    "tradeSuccess": "Transaksi Berhasil",
    "tradeFailed": "Transaksi Gagal",
    "kycRetryRequired": "KYC gagal. Silakan verifikasi lagi.",
    "viewNow": "Lihat sekarang"
  },
  "wallet": {
    "chooseCoin": "Pilih mata uang lain",
    "selectToken": "Pilih Token",
    "chooseNetwork": "Pilih Jaringan",
    "copyAddress": "Salin alamat",
    "copySuccess": "Berhasil Disalin",
    "copyFailed": "Gagal Menyalin",
    "saveSuccess": "Berhasil disimpan",
    "saveFailed": "Save failed",
    "depositAddress": "Deposit Address",
    "topupNotes": "Catatan Penting:",
    "topupNote1Prefix": "1. Jumlah isi ulang berdasarkan",
    "topupNote1Highlight1": "“Saldo yang diterima”",
    "topupNote1Middle": " sesuai dengan platform",
    "topupNote1Highlight2": "“Saldo yang diterima”",
    "topupNote1Suffix": " may differ across platforms because outgoing platform fees are deducted before arrival.",
    "topupNote2": "2. Do not deposit any non-USDT assets to the address above, or the assets may not be recoverable.",
    "topupNote3": "3. After depositing to the address above, network confirmation is required. Funds arrive after 60 confirmations and can be withdrawn after 910 confirmations.",
    "withdrawAddress": "Withdraw Address",
    "enterWithdrawAddress": "Masukkan atau tempel alamat dompet",
    "withdrawAmount": "Withdraw Amount",
    "withdrawAmountLabel": "Jumlah",
    "maxAmountLabel": "Maximum Amount",
    "available": "Tersedia",
    "enterAmount": "Isi jumlah",
    "enterWithdrawAmount": "Isi jumlah penarikan",
    "all": "Semua",
    "fee": "Biaya",
    "received": "Perkiraan saldo diterima",
    "submitWithdraw": "Ajukan permintaan penarikan",
    "withdrawNotes": "Catatan Penting:",
    "withdrawNote1Prefix": "Jumlah penarikan minimum adalah ",
    "withdrawNote2": "Pastikan alamat penarikan benar agar aset tidak hilang.",
    "withdrawNote3Prefix": "Setelah disetujui, dana akan diterima dalam ",
    "withdrawNote3Suffix": " jam. Gangguan jaringan dapat menyebabkan keterlambatan.",
    "withdrawNote4": "Jika dana belum diterima dalam waktu lama, hubungi layanan pelanggan.",
    "withdrawUnavailable": "Penarikan sementara tidak tersedia",
    "withdrawConfirm": "Confirm withdrawal?",
    "withdrawSuccess": "Permintaan penarikan berhasil diajukan, silakan menunggu persetujuan administrator",
    "withdrawSubmittedHeader": "Permohonan diajukan",
    "withdrawSubmittedTitle": "Permohonan penarikan telah diajukan",
    "withdrawUnderReview": "Sedang ditinjau",
    "withdrawReviewEta": "Permohonan penarikan Anda telah diajukan. Diperkirakan disetujui dalam 1 hari kerja dan dana akan segera dikreditkan.",
    "withdrawSubmitNotice": "Permohonan berhasil diajukan. Jangan ajukan kembali.",
    "withdrawViewFlowHint": "Anda dapat memeriksa dana masuk di Beranda > Fitur > Riwayat transaksi.",
    "billTitle": "Riwayat transaksi",
    "billDetailTitle": "detail",
    "noBill": "No records",
    "noBillDetail": "Tidak ada data yang tersedia",
    "assetType": "Jenis",
    "recordType": "Record Type",
    "billTransactionType": "Jenis Transaksi",
    "billTransferFriend": "Teman Penerima",
    "billTransferFriendId": "ID Teman Penerima",
    "billTimeLabel": "Waktu",
    "choosePricingFiat": "Pilih Mata Uang Penilaian",
    "hotFeatures": "Fitur Populer",
    "moreFeatures": "Fitur Lainnya",
    "walletFeatures": "Fitur Populer",
    "cardFeatures": "Fitur Kartu",
    "otherFeatures": "Fitur Lain",
    "payment": "Diterima",
    "scanCode": "Pindai",
    "walletBackup": "Cadangan Dompet",
    "openCard": "Buka Kartu Sekarang",
    "GoOpenCard": "Go open the card",
    "physicalCard": "Fitur kartu fisik",
    "physicalUnavailable": "The physical card feature is temporarily unavailable. Stay tuned!",
    "activateCard": "Aktifkan kartu fisik",
    "physicalTransfer": "Physical Transfer",
    "fundTransfer": "Transfer",
    "fundTransferUnavailable": "Fitur ini belum tersedia. Nantikan pembaruannya!",
    "receiveAddress": "Alamat penerima",
    "userId": "ID pengguna",
    "transferFriendId": "ID teman untuk transfer",
    "transferFriend": "Transfer ke teman",
    "transferToUser": "Transfer ke Pengguna ZorPay",
    "transferToExternalWallet": "Transfer ke Dompet Eksternal",
    "transferIdentityVerification": "Verifikasi identitas",
    "transferEmailVerificationDesc": "Untuk melindungi akun, verifikasi email sebelum transfer.",
    "withdrawEmailVerificationDesc": "Untuk melindungi akun, verifikasi email sebelum melakukan penarikan.",
    "transferVerifyEmail": "Verifikasi email",
    "transferEmailCodeExpires": "Kode verifikasi email berlaku selama 10 menit",
    "receiveUser": "Pengguna Penerima",
    "saveCollectionCode": "Simpan kode pengumpulan",
    "transferInProperty": "Only transfer assets through {network}",
    "receiveTips": "Receive Tips",
    "receiveTip1": "Confirm the asset and current network before receiving.",
    "receiveTip2": "Wrong network or coin transfers may not be recoverable.",
    "openCamera": "Open Camera",
    "closeCamera": "Close Camera",
    "pasteScanResult": "Paste or enter scan result",
    "scanResult": "Scan Result",
    "cameraUnavailable": "Camera is unavailable in this browser",
    "cameraPermissionDenied": "Camera access is blocked. Please allow camera permission first.",
    "cameraPermissionHint": "If no permission prompt appears, check whether camera access is allowed in site permissions.",
    "cameraNotFound": "No camera device was found.",
    "cameraInUse": "Camera is currently being used by another app. Please close it and try again.",
    "cameraConstraintFailed": "The requested camera mode is not supported on this device, and fallback also failed.",
    "cameraSecureContextRequired": "This page is not running in a camera-safe browser context.",
    "cameraSecureContextHint": "On Android browsers, webpage camera access usually requires HTTPS or localhost. Using a LAN http address often will not trigger camera permission directly.",
    "cameraGuideTitle": "Unable to open camera",
    "iosCameraGuideTitle": "iPhone camera guide",
    "androidCameraGuideTitle": "Android camera guide",
    "cameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "cameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "cameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "iosCameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "iosCameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "iosCameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "androidCameraPermissionGuide": "1. Open Site Settings or Permissions in your Android browser for this website.<br/>2. Change Camera permission to Allow.<br/>3. If the system camera permission was denied before, open Android Settings - Apps - Browser - Permissions and allow Camera.<br/>4. Return to the page, refresh it, and tap scan again.",
    "androidCameraSecureGuide": "Most Android browsers require a secure context for camera access.<br/>1. Make sure the page is opened from the official domain or an HTTPS link.<br/>2. If you are using a LAN address, many Android browsers will not trigger camera permission.<br/>3. Switch to the official address, refresh the page, and try again.",
    "androidCameraUnavailableGuide": "1. First make sure the system Camera app works normally on your phone.<br/>2. Check that both the browser and Android system allow camera permission.<br/>3. Close other apps that may be using the camera and try again.<br/>4. If it still fails, refresh the page or try the system browser.",
    "androidScanGuideTitle": "Android scan guide",
    "androidScanGuide": "The camera is open, but this Android browser does not support the live scanning capability used on this page.<br/>1. Try the system browser or the latest Chrome first.<br/>2. Make sure camera permission is allowed for this website.<br/>3. Refresh the page and try again. If it still fails, switch to a browser that supports live web scanning.",
    "safariScanGuideTitle": "Safari scan guide",
    "safariScanGuide": "The camera is open, but iPhone Safari does not support the live scanning capability used on this page.<br/>1. First confirm camera permission is allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still cannot scan, please use a browser that supports live web scanning or complete scanning from another entry.",
    "scanNotSupportedGuide": "This browser does not support the live scanning capability used on this page.<br/>1. Make sure camera permission is already allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still fails, please switch to the system browser or another browser that supports live web scanning.",
    "scanNotSupported": "This browser does not support live QR scanning. Please try again in your system browser.",
    "scanSuccess": "Scanned",
    "transferRecord": "Catatan transfer akun",
    "directTransfer": "Transfer langsung",
    "addressBookTransfer": "Transfer alamat",
    "scanTransfer": "Transfer pemindaian",
    "enterOrPasteAddress": "Enter or paste address",
    "enterUserId": "Masukkan ID pengguna",
    "enterZorPayId": "Masukkan ID ZorPay 8 digit",
    "onlySupport8DigitUserId": "Hanya mendukung ID pengguna 8 digit",
    "transferAmount": "Jumlah transfer",
    "availableAmount": "Tersedia {amount} {symbol}",
    "walletBalance": "Saldo Wallet",
    "transferHistory": "Riwayat transfer",
    "noTransferRecord": "No transfer records",
    "transferConfirm": "Confirm transfer?",
    "transferNetworkUnsupported": "Jaringan saat ini tidak mendukung transfer aset ini",
    "transferInsufficientBalance": "Saldo tidak cukup untuk jumlah transfer dan biaya jaringan",
    "haveNotFinishedTransaction": "Masih ada transfer yang tertunda. Silakan coba lagi nanti.",
    "transferSubmitted": "Transfer berhasil dikirim",
    "transferFriendSuccessTitle": "Transfer berhasil",
    "transferFriendSentAmount": "Berhasil mengirim {amount} {symbol}",
    "transferFriendRecipient": "Kami telah mengirim aset digital Anda kepada\npengguna dengan ID: {userId}",
    "transferApplySubmittedTitle": "Permohonan dikirim",
    "transferApplySubmitted": "Permintaan transfer telah dikirim",
    "transferUnderReview": "Transfer sedang ditinjau",
    "transferReviewEta": "Permintaan transfer Anda telah dikirim dan diperkirakan ditinjau dalam 1 hari kerja sebelum segera dikreditkan.",
    "transferSubmitNotice": "Permintaan transfer berhasil dikirim. Jangan ajukan kembali.",
    "transferViewFlowHint": "Buka Beranda > Fitur > Arus Dana untuk melihat catatan transfer.",
    "transferContactSupport": "Perlu bantuan? Hubungi layanan pelanggan",
    "addToken": "Tambah Token",
    "addNft": "Tambahkan NFT",
    "nftDetail": "Detail NFT",
    "nftAssets": "Saldo",
    "nftAssetView": "NFT",
    "nftSendTitle": "Kirim NFT",
    "nftSendAsset": "Saldo",
    "sendNft": "Kirim",
    "removeNft": "Hapus",
    "invalidAddress": "Please enter a valid address",
    "userIdNotFound": "Pengguna tidak ditemukan atau tidak tersedia di jaringan saat ini",
    "nftTransferUnsupported": "NFT transfer is not supported on the current network",
    "nftSendSuccess": "Berhasil terkirim",
    "hotToken": "Token Popular",
    "hotNft": "NFT Populer",
    "customToken": "Token Tersuai",
    "customNft": "NFT Kustom",
    "enterContractAddressSearch": "Enter contract address to search",
    "tokenAddress": "Alamat token",
    "nftAddress": "NFT Address",
    "enterTokenAddress": "Isi alamat token",
    "enterNftAddress": "Enter NFT contract address",
    "tokenSymbol": "Simbol token",
    "enterTokenSymbol": "Isi simbol token",
    "decimalPlaces": "Tempat desimal",
    "tokenAdded": "Token ditambah",
    "addSuccess": "Berjaya ditambah",
    "tokenDetail": "Detail Token",
    "propertyBalance": "Saldo Aset",
    "transferIn": "Transfer masuk",
    "transferOut": "Transfer keluar",
    "transferInAddress": "Alamat Penerimaan",
    "transferOutAddress": "Alamat Transfer",
    "transactionId": "ID Transaksi",
    "blockchainBrowser": "Penjelajah Blockchain",
    "network": "Jaringan",
    "pending": "Pending",
    "inTransaction": "Dalam Transaksi",
    "finish": "Selesai",
    "signTodo": "Signing flow migration in progress",
    "exportMnemonic": "Ekspor frasa",
    "exportPrivateKey": "Ekspor Kunci Pribadi",
    "sensitiveExportLabel": "Identity verification required",
    "securityReminder": "Peringatan Keamanan",
    "backupTip1": "Mnemonic and private key control your assets. Keep them offline.",
    "backupTip2": "Do not screenshot, record, or send them to anyone.",
    "backupTip3": "WinPay never stores your mnemonic or private key.",
    "backupSensitiveConfirm": "Make sure your surroundings are secure before continuing.",
    "sensitiveExportTodo": "Sensitive export flow migration in progress",
    "privateKeyUnavailable": "No private key export available for this wallet",
    "specialReminder": "Pengingat khusus",
    "safetyReminder": "Peringatan Keamanan",
    "privateCarefulExport": "After exporting the private key, store it offline with extreme care. Exposure may lead to asset loss.",
    "clickShowPrivateKeyQr": "Klik untuk menampilkan kode QR kunci pribadi",
    "plaintextPrivateKey": "Kunci Pribadi Teks Biasa",
    "copyPrivateKey": "Salin Kunci Pribadi",
    "copyPrivateKeyAfter": "After copying the private key, be sure to store it properly, otherwise it may cause asset loss.",
    "copyMnemonicAfter1": "Setelah menyalin frasa pemulihan, ",
    "copyMnemonicAfter2": "jangan buka aplikasi lain",
    "copyMnemonicAfter3": " untuk mencegah kebocoran clipboard.",
    "notPasteMnemonic1": "Jangan tempelkan frasa pemulihan Anda ke ",
    "notPasteMnemonic2": "frasa pengingat Anda ke aplikasi yang terhubung ke internet,",
    "notPasteMnemonic3": "Jangan gunakan ",
    "notPasteMnemonic4": "cadangkan ke layanan penyimpanan online atau alat obrolan",
    "notShareMnemonic1": "Jangan pernah bagikan frasa pengingat Anda kepada siapapun,",
    "notShareMnemonic2": "kami tidak akan pernah meminta frasa pengingat Anda",
    "winpayCard": "WinPay Card",
    "openCardTitle": "Buka Kartu Sekarang",
    "openCardDesc": "Connect account assets with global payments",
    "openCardProcess": "Open Card Flow",
    "openCardStep1": "Verifikasi KYC",
    "openCardStep2": "Pilih kartu",
    "openCardStep3": "Aktifkan",
    "cardSecure": "Aman",
    "cardSecureDesc": "Risk controls",
    "cardGlobal": "Global",
    "cardGlobalDesc": "Multi-scenario payments",
    "cardAsset": "Saldo",
    "cardAssetDesc": "Unified balance",
    "openCardNow": "Buka Kartu Sekarang",
    "cardKycTodo": "Card KYC flow migration in progress",
    "activatePhysicalCard": "Aktifkan kartu fisik",
    "activatePhysicalCardEntry": "Aktifkan kartu fisik",
    "activatePhysicalDesc": "Enter card number and activation code after receiving the card",
    "cardNumber": "Nomor kartu",
    "enterCardNumber": "Enter card number",
    "activeCode": "Kode Aktivasi",
    "enterActiveCode": "Enter activation code",
    "emailCode": "Kode email",
    "enterEmailCode": "Enter email code",
    "sendCode": "Send Code",
    "activateNow": "Activate Now",
    "activateTip1": "Activate only after receiving the physical card.",
    "activateTip2": "Check card number, email code, and activation code before submitting.",
    "cardApiTodo": "Card API migration in progress",
    "completeCardActiveForm": "Complete activation information",
    "activateSuccess": "Activated",
    "submitSuccess": "Submitted successfully",
    "physicalTransferDesc": "Balance transfer between physical cards",
    "fromCard": "From Card",
    "selectCard": "pilih",
    "toCard": "To Card",
    "enterTargetCard": "Enter target card number",
    "remark": "Catatan",
    "optionalRemark": "Optional",
    "completePhysicalTransferForm": "Complete transfer information",
    "transferFrom": "Dari",
    "transferTo": "Ke",
    "fundingAccount": "Akun Dana",
    "exchangeCoin": "Exchange Asset",
    "availableBalance": "Available Balance",
    "transferInAmount": "Transfer In Amount",
    "transferOutAmount": "Transfer Out Amount",
    "withdrawFeeLabel": "Biaya Penarikan",
    "failed": "Gagal"
  },
  "invite": {
    "title": "Undang",
    "inviteNow": "Undang Sekarang",
    "share": "Bagikan",
    "claim": "Klaim",
    "claimSuccess": "Diklaim",
    "pendingClaim": "Dapat Diklaim",
    "claimableAmount": "Dapat diklaim (USDT)",
    "claimed": "Sudah diklaim",
    "expired": "Kedaluwarsa",
    "copyUrl": "Salin link",
    "saveQrCode": "Simpan QR",
    "saveImage": "Simpan",
    "posterTitle": "Satu Kartu · Bayar Global",
    "posterTagline": "Pembayaran Global · Satu Dompet",
    "pointsRules": "Aturan undangan",
    "referralStepsTitle": "Langkah Referral",
    "pointsRulesComingSoon": "Segera hadir",
    "heroTitle": "Referral & Reward",
    "hero1": "Ajak & Raih hingga",
    "hero2": "60%",
    "hero3": "Hadiah",
    "heroDesc": "Lihat Aturan & Raih Reward",
    "partner": "Mitra",
    "partnerPromotion": "Jadi Mitra WinPay. Raih Lebih Banyak.",
    "partnerJoinNow": "Gabung Sekarang",
    "coursePromotionTitle": "Kelas Terbuka",
    "purchaseCardToInvite": "Beli kartu untuk membuka undangan",
    "purchaseCardToInviteDesc": "Anda telah menyelesaikan verifikasi identitas. Beli kartu virtual atau fisik untuk mendapatkan kode undangan dan tautan undangan eksklusif, lalu mulai mendapatkan hadiah undangan.",
    "unlockInviteTitle": "Syarat membuka kode dan tautan undangan:",
    "unlockInviteDesc": "Beli kartu apa pun untuk mendapatkan kode dan tautan undangan eksklusif Anda.",
    "purchaseCardToInviteLater": "Nanti saja",
    "purchaseCardToInviteNow": "Beli kartu sekarang",
    "kycPurchaseCardDesc": "Selesaikan verifikasi identitas, lalu beli kartu virtual atau fisik untuk membuka fitur ini.",
    "coursePromotionDesc": "Lihat Kursus & Raih Reward",
    "cardOpeningCommission": "Komisi pembukaan kartu",
    "spendingCommission": "Komisi belanja",
    "commissionRefundDeduction": "Potongan komisi akibat refund",
    "reservedReward": "Dicadangkan",
    "courseCommission": "Komisi kursus",
    "globalDirectorCourseCommission": "Komisi kursus Direktur Global",
    "globalDirectorCardOpeningCommission": "Komisi pembukaan kartu Direktur Global",
    "teamBonusPoolCardOpeningCommission": "Komisi pembukaan kartu dari kumpulan bonus tim",
    "teamBonusPoolCourseCommission": "Komisi kursus dari kumpulan bonus tim",
    "globalDirectorTeamCardOpeningCommission": "Komisi pembukaan kartu tim Direktur Global",
    "globalDirectorTeamCourseCommission": "Komisi kursus tim Direktur Global",
    "inviteFriendCardOpeningCommission": "Komisi dari mengundang teman membuka kartu",
    "invitationCommission": "Referral",
    "purchaseCommission": "Kartu",
    "consumptionCommission": "Kursus",
    "friendCourseCommission": "Komisi Kursus Teman",
    "inviteFriendCourseCommission": "Komisi kursus dari teman yang diundang",
    "monthlyCommission": "Bulanan",
    "monthlyBonusPoolCommission": "Reward Tim",
    "globalDirectorExclusiveCommission": "Komisi Eksklusif Direktur Global",
    "globalDirectorCardOpeningReward": "Imbalan Pembukaan Kartu Direktur Global",
    "monthlyCommissionTitle": "Tim",
    "monthlyCommissionIntro": "Kumpulkan lebih dari 5 pembukaan kartu valid dari referral langsung untuk memenuhi syarat mendapatkan reward tim V3.",
    "monthlyCommissionTip1": "Penyelesaian komisi pembukaan kartu",
    "monthlyCommissionTip1Desc": "Setelah mencapai V3, undang teman untuk menyelesaikan pembukaan kartu yang valid agar mendapatkan reward.",
    "monthlyCommissionTip2": "Reward bertingkat",
    "monthlyCommissionTip2Desc": "Diselesaikan dua kali sebulan; tingkat T ditentukan berdasarkan jumlah referral langsung yang valid.",
    "monthlyCommissionTip3": "Informasi reward tim",
    "monthlyCommissionTip3Desc": "Setelah teman menyelesaikan pembelian kursus yang valid, reward akan berkontribusi ke kumpulan reward tim setengah bulanan.",
    "monthlyCommissionTip4": "Penyelesaian reward tim",
    "monthlyCommissionTip4Desc": "Diselesaikan dua kali sebulan; jumlah akhir mengikuti hasil penyelesaian sistem.",
    "consumptionRefund": "Komisi Mengundang Teman Membuka Kartu",
    "friendConsumptionRewardRefund": "Refund reward teman",
    "rewardRecordCardOpeningTitle": "Undang [{friendName}] buka kartu",
    "rewardRecordConsumptionTitle": "[{friendName}] belanja",
    "rewardRecordRefundTitle": "[{friendName}] refund",
    "rewardRecordCourseCommissionTitle": "[{friendName}] komisi kursus",
    "rewardRecordFriendCourseCommissionTitle": "Undang [{friendName}] - komisi kursus teman",
    "rewardRecordMonthlyCommissionTitle": "[{friendName}] komisi bulanan",
    "rewardRecordMonthlyBonusPoolTitle": "[{friendName}] komisi kumpulan bonus bulanan",
    "rewardRecordRegistrationTitle": "Undang [{friendName}]",
    "invitationTotal": "Referral",
    "notUnlocked": "Belum dibuka",
    "purchaseCommissionTitle": "Hadiah Kartu",
    "purchaseCommissionIntro": "Raih hadiah saat teman mengaktifkan WinPay Card.",
    "purchaseCommissionTip1": "Semakin tinggi level, semakin tinggi tingkat komisi. ",
    "purchaseCommissionTip1Desc": "Undang lebih banyak teman untuk membuka kartu. Setelah memenuhi syarat, Anda dapat bergabung dengan kumpulan bonus tim.",
    "purchaseCommissionTip2": "Kartu virtual dan fisik mendapat hadiah yang sama setelah aktivasi.",
    "purchaseCommissionTip2Desc": "",
    "purchaseCommissionTip3": "Reward kartu cair otomatis setelah dibuka",
    "purchaseCommissionTip3Desc": "Dibayar dalam 3 hari kerja.",
    "purchaseCommissionTip3DescPrefix": "Dibayar dalam ",
    "purchaseCommissionTip3Time": "Kartu berhasil diaktifkan, komisi langsung diselesaikan.",
    "purchaseCommissionTip3DescSuffix": ". Hadiah otomatis dikirim ke akun total aset Anda.",
    "purchaseCommissionConfirm": "Saya mengerti",
    "consumptionCommissionTitle": "Kursus",
    "consumptionCommissionIntro": "Beli kursus untuk mendapatkan komisi eksklusif dari kursus yang valid.",
    "consumptionCommissionTip1": "Aturan reward belanja",
    "consumptionCommissionTip1Desc": "Semakin banyak teman yang Anda undang, semakin besar hadiah kursus yang Anda dapatkan",
    "consumptionCommissionTip2": "Aturan refund belanja",
    "consumptionCommissionTip2Desc": "Refund 30 hari: tidak ada reward.",
    "consumptionCommissionTip2Partial": "Refund sebagian",
    "consumptionCommissionTip2PartialDesc": "Hitung ulang sesuai belanja valid.",
    "consumptionCommissionTip3": "Refund setelah reward cair",
    "consumptionCommissionTip3Desc": "Pesanan refund atau batal dapat menarik kembali reward.",
    "points": "Poin Saya",
    "inviteMethod": "Cara undang",
    "invitationCode": "Kode undangan",
    "shareQr": "QR undangan",
    "invitationLink": "Link undangan",
    "myExclusiveInvite": "Referral Saya",
    "invitationCodeShort": "Code",
    "invitationLinkShort": "Tautan",
    "invitationRelationTip": "Gunakan kode/link untuk terhubung dan dapatkan reward.",
    "recommender": "Pereferal",
    "enterRecommenderCode": "Masukkan kode",
    "scanRecommenderCode": "Pindai kode",
    "viewFullRecords": "Lihat Semua",
    "personUnit": "orang",
    "invitedFriendsTotal": "Total Referral Valid",
    "pendingCommission": "Hadiah Tertunda",
    "totalCommission": "Total Hadiah",
    "parentCode": "Pengundang",
    "enterParentCode": "Masukkan kode undangan",
    "bind": "Ikat",
    "bound": "Terikat",
    "rewardDetails": "Detail reward",
    "commissionDetails": "Rincian Komisi",
    "recommendedUsers": "Teman referal",
    "tradingFriends": "Teman belanja",
    "registeredFriends": "Teman terdaftar",
    "noRecommendedUsers": "Belum ada teman",
    "totalCommissionUsdt": "Total Hadiah（USDT）",
    "withdrawable": "Dapat Diklaim",
    "pendingSettlement": "Tertunda",
    "pendingSettlementTitle": "Pending (USDT)",
    "pendingSettlementDescription": "Selesaikan sebelum klaim; refund membatalkan reward.",
    "pendingSettlementQuestion": "Kapan cair?",
    "pendingSettlementMonthlyCommission": "Komisi tim: diselesaikan dua kali sebulan",
    "pendingSettlementCardActivation": "Aktivasi kartu: komisi langsung diselesaikan dan dikreditkan setelah kartu berhasil diaktifkan",
    "pendingSettlementTransaction": "Komisi kursus: langsung diselesaikan dan dikreditkan setelah pembelian terverifikasi",
    "settled": "Selesai",
    "myRewards": "Hadiah Saya",
    "date": "Tanggal",
    "selectDate": "Pilih Tanggal",
    "rewardSuccess": "Berhasil",
    "rewardReady": "Dapat diklaim",
    "rewardVoided": "Dibatalkan",
    "rewardPartialRefund": "Refund sebagian",
    "rewardRefunded": "Dikembalikan",
    "rewardDeducted": "Dipotong",
    "rewardDeductionFailed": "Pemotongan gagal",
    "rewardCredited": "Telah dikreditkan",
    "rewardCardType": "Jenis kartu",
    "rewardType": "Jenis reward",
    "friendNickname": "Nama teman",
    "invitationRelation": "Hubungan referral",
    "indirectFriend": "Referral tidak langsung",
    "rewardAmount": "Reward",
    "percentageWeight": "Bobot persentase",
    "deductionAmount": "Potongan",
    "commissionAllocationRatio": "Rasio alokasi",
    "commissionAllocationRatioUnavailable": "Belum tersedia",
    "commissionSettlementCycle": "Siklus penyelesaian",
    "teamCommissionSettlementCycle": "Diselesaikan dua kali sebulan",
    "commissionSettlementMethod": "Metode penyelesaian",
    "commissionInstantSettlement": "Langsung dikreditkan",
    "commissionTriggerTime": "Waktu pemicu",
    "commissionSettlementTime": "Waktu cair",
    "friendConsumptionRefundTime": "Waktu refund teman",
    "commissionDeductionTime": "Waktu potongan",
    "commissionStatus": "Status",
    "rewardDetailsAmountPrefix": "Detail reward ",
    "balanceAfter": "Saldo ",
    "noRewardRecords": "Belum ada data",
    "inviteSteps": "Langkah undang",
    "step1": "Bagikan link atau kode",
    "step2": "Teman yang diundang menyelesaikan pengajuan kartu atau pembelian kursus melalui tautan atau kode undangan Anda",
    "step3": "Anda akan mendapatkan imbalan komisi saat teman mengaktifkan kartu atau membeli kursus"
  },
  "task": {
    "title": "Dapatkan Poin dengan Check-in",
    "dailyCheckIn": "check-in harian",
    "howToGetPoints": "Cara Mendapatkan Poin",
    "myPoints": "Poin Saya",
    "dailyTasks": "Tugas Harian",
    "checkInTotal": "Checked in for",
    "days": " hari berturut-turut",
    "checkInRules": "Aturan Check-in",
    "checkInRuleOne": "1. Check-in harian menampilkan 7 hari setiap kali; hadiah meningkat dalam siklus 5/10/15 poin setiap 3 hari.",
    "checkInRuleTwo": "2. Jika Anda melewatkan satu hari, hadiah akan direset dan dimulai lagi dari 5 poin.",
    "moreCheckInsMorePoints": "Semakin sering check-in, semakin banyak poin~",
    "checkedInDaysPrefix": "Sudah check-in selama ",
    "checkedInDaysSuffix": " hari berturut-turut",
    "checkedInTodayTomorrow": "Anda sudah check-in hari ini. Kembali lagi besok.",
    "routineTasks": "Tugas Rutin",
    "dailyPointsLimit": "Daily points limit 1000",
    "basicGrowth": "Pertumbuhan Dasar",
    "completeSignature": "Lengkapi Tanda Tangan",
    "signatureDone": "Tanda Tangan Selesai",
    "pointsPlusOne": "Poin +1",
    "goFollow": "Ikuti",
    "postMoments": "Posting ke Moments",
    "perPost": "Setiap 1 Postingan",
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun"
  },
  "card": {
    "title": "Kartu",
    "myCards": "Kartu saya",
    "openCard": "Ajukan Kartu",
    "benefits": "Manfaat Kartu",
    "bill": "Tagihan",
    "empty": "Tidak Ada Kartu Terkait",
    "virtualCard": "Kartu Virtual",
    "physicalCard": "Kartu Fisik",
    "courseCard": "Kartu Kursus",
    "courseGiftNoticePhysical": "Setelah berhasil membeli kartu fisik, Anda akan mendapatkan kursus tatap muka eksklusif. Tautan kursus akan dikirim ke email terdaftar Anda; klik untuk melihat detail dan cara berpartisipasi.",
    "courseGiftNoticeVirtual": "Setelah berhasil membeli kartu virtual, Anda akan mendapatkan kursus tatap muka eksklusif. Tautan kursus akan dikirim ke email terdaftar Anda; klik untuk melihat detail dan cara berpartisipasi.",
    "applyCard": "Ajukan Kartu",
    "applyNow": "Apply Now",
    "virtualDesc": "Contactless payments online and offline anytime, anywhere!",
    "physicalDesc": "Tanpa biaya tahunan. Dukung ATM global!",
    "applyCardTypeOne": "Ajukan kartu virtual",
    "applyCardTypeTwo": "Ajukan kartu fisik",
    "applyCardTip1": "Ajukan online untuk pembayaran online dan offline",
    "applyCardTip2": "Kartu fisik mendukung pengiriman ke rumah, penarikan ATM, dan pembayaran POS",
    "applyCardTip3": "Ajukan online, lalu aktifkan setelah menerima kartu fisik",
    "applyCardTip4": "Lihat dan kelola kartu virtual dan fisik",
    "applyCourseExclusiveCard": "Ajukan Kartu Kursus",
    "applyCourseExclusiveCardDesc": "Hanya untuk menampilkan manfaat, tanpa verifikasi, isi ulang, belanja, atau penarikan",
    "courseCardApplyTitle": "Ajukan Kartu Kursus",
    "courseCardNotice": "Kartu Kursus hanya digunakan untuk menampilkan manfaat. Verifikasi identitas tidak diperlukan dan isi ulang, belanja, serta penarikan belum didukung.",
    "openingFee": "Biaya kartu",
    "cardType": "Jenis kartu",
    "courseExclusiveCard": "Kartu Kursus",
    "identityVerification": "Verifikasi identitas",
    "noAuthenticationRequired": "Tidak diperlukan",
    "rechargeSupported": "Isi ulang",
    "spendingSupported": "Belanja",
    "withdrawalSupported": "Penarikan",
    "notSupportedYet": "Belum didukung",
    "applicableScenes": "Penggunaan pilihan",
    "studyImprovement": "Peningkatan belajar",
    "promotionMonetization": "Promosi",
    "brandCooperation": "Kerja sama merek",
    "openingBenefits": "Manfaat pembukaan",
    "receiveCourseCard": "Terima kartu",
    "receiveCourseCardDesc": "Beli Kartu Kursus untuk menerima satu kartu kursus eksklusif.",
    "promotionRights": "Aktifkan akses promosi",
    "promotionRightsDesc": "Setelah verifikasi dan pembayaran berhasil, akses promosi kursus eksklusif akan diaktifkan.",
    "openNow": "Buka sekarang {amount} USDT",
    "purchaseSuccessTitle": "Pembelian Berhasil",
    "purchaseSuccessful": "Pembelian berhasil",
    "purchaseSuccessDesc": "Manfaat Kartu Kursus Anda kini aktif",
    "promotionActivated": "Akses promosi diaktifkan",
    "promotionActivatedDesc": "Sekarang Anda dapat mengundang teman untuk berpartisipasi dalam promosi.",
    "cardSecured": "Manfaat kartu hadiah Anda telah disimpan",
    "cardSecuredDesc": "Anda dapat menerima kartu virtual atau fisik gratis. Kartu hadiah sedang dipersiapkan dan Anda akan diberi tahu saat tersedia.",
    "goPromote": "Promosikan",
    "done": "Selesai",
    "directPromotion": "Promosikan sekarang",
    "pendingOpen": "Akan dibuka",
    "kycDialogTitle": "Verifikasi identitas",
    "kycDialogDesc": "Selesaikan verifikasi identitas untuk membuka fitur ini",
    "kycDialogAction": "KYC sekarang",
    "useInstruction": "Panduan Kartu",
    "virtualCardUseInstruction": "Petunjuk penggunaan kartu virtual",
    "entityCardUseInstruction": "Petunjuk penggunaan kartu fisik",
    "useInstructionText1": "Kartu virtual mendukung Alipay, Meituan, dan pembayaran online.",
    "useInstructionText2": "Kartu fisik mendukung Alipay, Meituan, pembayaran online/offline, POS, dan tarik tunai ATM.",
    "useInstructionText3": "Jangan bagikan nomor kartu, masa berlaku, atau CVV kepada orang lain.",
    "useInstructionText4": "Setelah dilepas, kartu tidak dapat dipulihkan. Tindakan ini tidak dapat dibatalkan.",
    "useInstructionText5": "Setelah pelepasan, biaya kartu tidak dikembalikan, tetapi sisa saldo kembali ke dompet Anda.",
    "useInstructionText6": "Jika butuh bantuan, buka Saya - Hubungi Kami - Dukungan Online.",
    "useInstructionText7": "Cara menghubungkan",
    "useInstructionText8": "Alipay",
    "useInstructionText9": "Ikuti langkah berikut untuk menghubungkan kartu Anda dengan cepat dan mudah",
    "useInstructionText10": "Buka Alipay",
    "useInstructionText11": "Buka aplikasi Alipay dan ketuk Saya",
    "useInstructionText12": "Masuk ke Kartu Bank",
    "useInstructionText13": "Pilih pintu masuk tambah kartu di Kartu Bank atau Pengaturan Pembayaran",
    "useInstructionText14": "Tambah kartu bank",
    "useInstructionText15": "Ketuk Tambah Kartu Bank dan masukkan nomor kartu WinPay Anda",
    "useInstructionText16": "Isi informasi kartu",
    "useInstructionText17": "Masukkan masa berlaku, CVV, kode verifikasi, dan info yang diperlukan.",
    "useInstructionText18": "Selesaikan verifikasi",
    "useInstructionText19": "Setelah dikirim, selesaikan verifikasi SMS atau keamanan untuk menautkan kartu.",
    "useInstructionText20": "Petunjuk penggunaan kartu",
    "bindCardInfo1": "Kartu Visa ini dipilih untuk penggunaan Alipay dan dapat ditautkan dengan cepat melalui langkah berikut.",
    "bindCardInfo2": "Kartu Visa ini dipilih untuk penggunaan Google Pay dan dapat ditautkan dengan cepat melalui langkah berikut.",
    "bindCardInfo3": "Kartu Visa ini dipilih untuk penggunaan Apple Pay dan dapat ditautkan dengan cepat melalui langkah berikut.",
    "bindCardInfo4": "Unduh dan buka Google Pay, lalu masuk ke akun",
    "bindCardInfo5": "Di halaman utama Google Pay, ketuk Tambahkan kartu pembayaran",
    "bindCardInfo6": "Tambahkan kartu pembayaran",
    "bindCardInfo7": "Ketuk Tambahkan kartu kredit atau debit",
    "bindCardInfo8": "Isi informasi pribadi",
    "bindCardInfo9": "Isi detail kartu dan alamat penagihan, lalu ketuk Simpan dan lanjutkan",
    "bindCardInfo10": "Buka halaman ketentuan penerbit kartu",
    "bindCardInfo11": "Gulir ke bawah lalu ketuk Lanjutkan",
    "bindCardInfo12": "Pilih metode verifikasi, minta kode, masukkan kode pada kolom verifikasi, lalu selesaikan verifikasi untuk menautkan kartu",
    "bindCardInfo13": "Unduh dan buka Apple Pay, lalu masuk ke akun",
    "bindCardInfo14": "Di halaman utama Apple Pay, ketuk Tambahkan kartu pembayaran",
    "bindCardInfo15": "Pindai atau masukkan detail kartu secara manual",
    "bindCardInfo16": "Isi nomor kartu, nama dalam bahasa Inggris, tanggal kedaluwarsa, dan kode keamanan",
    "bindCardInfo17": "Buka halaman syarat dan ketentuan",
    "bindCardInfo18": "Gulir ke bawah lalu ketuk Setuju",
    "coreAdvantages": "Keunggulan utama",
    "recommendedAudience": "Pengguna yang disarankan",
    "cardScene": "Card Scene",
    "transferIn": "Transfer masuk",
    "transferOut": "Transfer keluar",
    "atmPassword": "PIN ATM",
    "cardInfo": "Info kartu",
    "mycard": "Kartu saya",
    "benefit": "Manfaat Kartu",
    "recentTrade": "Tagihan",
    "viewAll": "Lihat semua",
    "noTrade": "No trade records",
    "noTradeEmpty": "Tidak ada data yang tersedia",
    "inUse": "Sedang Digunakan",
    "inactive": "Belum aktif",
    "frozen": "Dibekukan",
    "processing": "Sedang diproses",
    "success": "Sukses",
    "failed": "Gagal",
    "cardSensitiveTodo": "Sensitive card info flow migration in progress",
    "cardWallet": "Kartu",
    "cardBenefits": "Manfaat Kartu",
    "noBenefit": "No benefit info",
    "withdrawMin": "Min Withdraw",
    "withdrawMax": "Max Withdraw",
    "rechargeMin": "Min Recharge",
    "rechargeMax": "Max Recharge",
    "monthlyLimit": "Monthly Limit",
    "billDetail": "Rincian Tagihan",
    "feeRate": "Payment Fee",
    "chargeFeeLabel": "Biaya Isi Ulang",
    "rechargeFeeLabel": "Initial Recharge",
    "withdrawFeeLabel": "Biaya Penarikan",
    "payFeeLabel": "Biaya Pengeluaran",
    "selectCardTemplate": "Select Card Template",
    "selectScene": "Select Scene",
    "cardTemplate": "Card Template",
    "scene": "Scene",
    "selectTimeRange": "Pilih Rentang Waktu",
    "timeRangeTip": "Beralih ke 180 hari terakhir untuk melihat detail imbalan",
    "last30Days": "30 Hari Terakhir",
    "last90Days": "90 Hari Terakhir",
    "last180Days": "180 Hari Terakhir",
    "currentScenario": "Current Scenario",
    "supportedScenes": "Supported Scenes",
    "supportedPlatforms": "Supported Platforms",
    "platformHint": "Subject to issuer support rules",
    "openCardAmount": "Biaya Pembukaan Kartu",
    "openCardAmountTip": "Includes issuance fee and initial recharge",
    "openFeeNoticePrefix": "Biaya pembukaan kartu",
    "openFeeNoticeSuffix": "akan dikreditkan ke kartu untuk menjaga kartu tetap aktif",
    "firstRechargeTip": "Opening the card requires {amount} {symbol}, plus an initial recharge of {charge} {symbol}",
    "cardTitlePrefix": "Kartu ",
    "cardUsageLimit": "Spending Limit",
    "monthlyCardUsageLimit": "Batas konsumsi/bulan",
    "prepaidCard": "Kartu Prabayar",
    "identityInfo": "Informasi Identitas",
    "identityInfoTip": "Verified details will be used for card opening checks",
    "firstName": "Nama",
    "lastName": "Nama Belakang",
    "identityInfoEmpty": "Please complete verified identity details first",
    "agreementPrefix": "Saya telah membaca dan menyetujui",
    "optionalInvitationCode": "Isi kode undangan (opsional)",
    "openCardNotice": "Opening Notes",
    "openCardNotice1": "The opening cost consists of the issuance fee and initial recharge amount, processed automatically after submission.",
    "openCardNotice2": "Supported platforms and fees vary by scenario and issuing channel. Final rules are subject to the provider.",
    "openCardNotice3": "If you plan to apply for a physical card later, make sure you already hold a bindable virtual card.",
    "termsAgree": "I have read and agree to the User Agreement and Privacy Policy",
    "agreeFirst": "Please agree to the terms first",
    "noCardTemplate": "No card templates are currently available",
    "balanceOverview": "Ringkasan manfaat kartu",
    "withdrawNotice": "Minimum physical card withdrawal {amount} {symbol}",
    "applyPhysicalCard": "Apply Physical Card",
    "physicalApplyDesc": "Verify identity, choose a template, fill shipping information, and wait for card production after payment.",
    "shippingFee": "Shipping",
    "shippingFree": "Free",
    "applicationFee": "Application Fee",
    "applicationFeeLabel": "Biaya pengajuan: ",
    "recentTradeScene": "Skenario Penggunaan yang Dipilih",
    "physicalSceneDesc": "Pengeluaran online dan offline",
    "physicalOrderNotice": "Physical Card Notes",
    "physicalNotice1": "Open a bindable virtual card before applying for a physical card.",
    "physicalNotice2": "After successful payment, the card enters production and delivery.",
    "physicalNotice3": "Activate the card after receiving it before use.",
    "fillShippingInfo": "Isi info pengiriman",
    "requireVirtualCardFirst": "Open a bindable virtual card before applying for a physical card",
    "cardInfoTitle": "Info kartu",
    "shippingInfoTitle": "Info pengiriman",
    "sameAsVirtualCard": "Sama seperti kartu virtual",
    "receiverName": "Nama",
    "enterReceiverName": "Isi",
    "completeAllInfo": "Lengkapi semua informasi",
    "addressMinLength": "Alamat minimal 5 karakter",
    "completeShippingAddress": "Complete shipping information. Address must be at least 5 characters.",
    "saveLabel": "Simpan",
    "confirmOrder": "Konfirmasi info pesanan",
    "payPhysicalCardConfirm": "Confirm the physical card order and proceed to payment?",
    "payNow": "Bayar Sekarang",
    "orderPaid": "Pembayaran berhasil",
    "paymentDetail": "Detail pembayaran",
    "paymentFee": "Biaya dibayar",
    "paymentSuccess": "Pembayaran berhasil",
    "paymentSuccessDesc": "Kartu Anda sedang dibuat. Perkiraan tiba 7-14 hari kerja.",
    "physicalCardMakingTip": "Kartu fisik memerlukan waktu lebih lama. Aktifkan setelah diterima.",
    "paymentAmount": "Biaya dibayar",
    "physicalArrivalTip1": "Physical card production usually takes longer. Please wait patiently.",
    "physicalArrivalTip2": "Activate the card first after delivery before using it.",
    "viewPendingCards": "View Pending Cards",
    "totalAssetsInsufficientBalance": "Insufficient total assets. Please top up before continuing.",
    "currentCardInsufficientBalance": "Saldo kartu tidak cukup. Silakan isi saldo dulu.",
    "topUpNow": "Isi saldo",
    "pendingPhysicalCards": "Kartu belum aktif",
    "pendingActivate": "Belum aktif",
    "noPendingPhysicalCard": "No physical cards pending activation",
    "hasInactiveCards": "Ada kartu yang belum diaktifkan",
    "physicalInstruction": "Penjelasan kartu fisik",
    "pendingNotice1": "You have successfully applied for a physical card. It is now being produced or shipped.",
    "pendingNotice2": "For account security, the physical card cannot be used before activation.",
    "pendingNotice3": "Setelah menerima kartu, tekan tombol di bawah untuk aktivasi.",
    "contactSupport": "Hubungi dukungan",
    "invitationCode": "Kode undangan",
    "enterInvitationCode": "Isi kode undangan (opsional)",
    "openCardConfirm": "Submit card application?",
    "openCardSuccess": "Card application submitted",
    "kycTitle": "Verifikasi KYC",
    "kycVerify": "Verifikasi KYC",
    "kycRequirement": "Selesaikan verifikasi KYC sebelum mengajukan kartu.",
    "kycRequirement1": "Provide real and accurate information consistent with your document.",
    "kycRequirement2": "Verification is reviewed by the provider and may take some time.",
    "kycIntroTip": "Submit real identity details first. After approval, you can continue opening a virtual card.",
    "verifyNow": "Verifikasi Sekarang",
    "fillInfo": "Isi informasi",
    "kycFormTip": "Fill in your usual contact details and billing address exactly as required.",
    "contactAndAddress": "Contact and Address",
    "countryCode": "Kode",
    "selectCountryCode": "Select code",
    "phoneNumber": "Nomor Telepon",
    "enterPhone": "Isi nomor telepon Anda",
    "address": "Alamat",
    "selectCountry": "Select country",
    "selectCountryRegion": "Pilih negara/wilayah",
    "searchCountry": "Cari negara",
    "selectRegion": "Select state/province/region",
    "selectCity": "Pilih kota",
    "enterAddress": "Enter detailed address",
    "postalCode": "Kode Pos",
    "enterPostalCode": "Enter postal code",
    "completeKycAddress": "Complete address info. Address must be at least 5 characters.",
    "kycSubmitted": "Information submitted",
    "kycReview": "Tinjauan Informasi",
    "kycRejected": "Verifikasi KYC ditolak",
    "kycPending": "Informasi berhasil dikirim, menunggu peninjauan",
    "kycApproved": "Info disetujui",
    "kycRejectedTip": "Please revise the information according to the rejection reason and resubmit.",
    "reviewTip": "Review finished, select a card to activate",
    "reviewDone": "saya mengerti",
    "cardCanOpen": "Sekarang Anda bisa memilih kartu",
    "resubmit": "Kirim Ulang",
    "failedReason": "Alasan Kegagalan",
    "activatePending": "{count} physical cards pending activation",
    "oldCardTransferTip": "Legacy cards do not support transfer in / out after the WinPay card service upgrade.",
    "oldCardServiceUpgradeNotice": "WinPay telah meningkatkan layanan kartu virtual dan fisiknya. Kartu lama untuk sementara tidak mendukung transfer masuk atau transfer keluar. Terima kasih atas pengertiannya.",
    "cardProcessingWait": "Card is still processing. Please try again later.",
    "cardBalance": "Card Balance",
    "accountBalance": "Funding Balance",
    "availableBalanceLabel": "Saldo Tersedia:",
    "rechargeCurrencyTitle": "Mata Uang Pengisian",
    "rechargeAmountTitle": "Jumlah Isi Ulang",
    "monthlyFee": "Biaya Bulanan",
    "supportedConsumptionScenes": "Skenario Pengeluaran yang Didukung",
    "keySupportedPlatforms": "Platform Utama yang Didukung",
    "allSupportedPlatforms": "Semua platform yang didukung",
    "otherServices": "Other Services",
    "otherPlatforms": "Layanan Lainnya",
    "cardUsageRules": "Panduan Penggunaan Kartu",
    "usageRule1": "Tingkat pengembalian dana, pembatalan, kegagalan, atau verifikasi yang tinggi dapat menyebabkan risiko pembekuan kartu",
    "usageRule2": "Dilarang digunakan di platform seperti Steam, Blizzard, EA, Battle.net, OYSTER LABS, dll.",
    "usageRule3": "Dilarang mengikat platform berlangganan untuk pemotongan otomatis",
    "cardSafetyTips": "Tips Keamanan Penggunaan Kartu",
    "cardSafetyTip1": "Jangan sembarangan memberitahukan nomor kartu, tanggal kedaluwarsa, CVV, dll., kepada orang lain",
    "cardSafetyTip2": "Harap gunakan kartu prabayar secara sah dan hanya dalam lingkup kepatuhan terhadap kartu.",
    "unbindCard": "Lepaskan Kartu",
    "unBindCardText_1": "Sebelum melepas kaitan kartu Anda, perhatikan saldo pada kartu:",
    "unBindCardText_2": "Sisa saldo akan dikembalikan ke aset akun Anda dalam 1-7 hari kerja setelah pelepasan. Cek riwayat atau hubungi dukungan.",
    "unBindCardText_3": "Dampak berikut akan terjadi setelah pelepasan kaitan",
    "unBindCardText_4": "Kartu ini tidak lagi dapat digunakan untuk pembayaran dan transaksi terkait",
    "unBindCardText_5": "Layanan pembayaran otomatis yang terikat pada kartu ini mungkin akan terpengaruh",
    "unBindCardText_6": "Setelah dilepas, kartu ini tidak dapat diikat kembali",
    "unBindCardText_7": "Pelepasan kaitan sedang diproses",
    "unBindCardText_8": "Sedang melepas kaitan kartu...",
    "unBindCardText_9": "Mohon tunggu, diperkirakan memerlukan dua menit",
    "unBindCardText_10": "Untuk melindungi dana Anda, pelepasan kaitan tidak dapat dipulihkan",
    "unBindCardText_11": "Berhasil dilepas",
    "unBindCardText_12": "Kartu berhasil dilepas",
    "unBindCardText_13": "Kartu Anda telah berhasil dilepas dan tidak akan lagi muncul di daftar kartu",
    "unBindCardText_14": "Pelepasan kaitan gagal",
    "unBindCardText_15": "Pelepasan kaitan kartu gagal",
    "unBindCardText_16": "Gagal melepas kartu ini. Silakan coba lagi nanti.",
    "unBindCardText_17": "Kartu yang sudah dilepas",
    "unBindCardText_18": "Sudah dilepas",
    "unBindCardText_19": "Detail kartu yang sudah dilepas",
    "unBindCardText_20": "Jumlah sisa saat melepas kartu:",
    "unBindCardText_21": "Apakah pengembalian dana sisa saldo berhasil:",
    "unBindCardText_22": "Waktu pelepasan kartu:",
    "unbindCardStatus": "Status kartu",
    "unbindRefundYes": "Ya",
    "unbindRefundPending": "Sedang diproses",
    "minAmount": "Minimum Amount",
    "exchangeRate": "Harga Saat Ini",
    "chargeArrivalTitle": "Saldo Masuk",
    "expectedCardArrival": "Perkiraan saldo diterima",
    "expectedAccountArrival": "Penarikan Tiba",
    "submitTransfer": "Konfirmasi",
    "transferSuccess": "Transfer Dikirim",
    "transferSuccessTitle": "Tips",
    "transferInSuccessDesc": "Selamat, Anda berhasil melakukan isi ulang",
    "transferOutSuccessDesc": "Selamat, Anda telah berhasil menarik uang",
    "enterChargeAmount": "Isi jumlah isi ulang",
    "enterTransferInAmount": "Enter transfer in amount",
    "enterTransferOutAmount": "Enter transfer out amount",
    "enterValidAmount": "Enter a valid amount",
    "tradeDetail": "Detail",
    "tradeProcessingTip": "This transaction is still processing. Check back later for the final result.",
    "cardNumber": "Nomor kartu",
    "tradeType": "Jenis transaksi",
    "tradeDescription": "Catatan",
    "merchant": "Merchant",
    "amount": "Amount",
    "tradeAmount": "Jumlah transaksi",
    "orderNumber": "Order Number:",
    "orderId": "Order ID",
    "tradeTime": "Waktu",
    "noTradeDetail": "No trade detail available",
    "cvvTip": "The CVV is the 3 or 4 digit code on the back of the card used to verify your identity.",
    "sensitiveInfoLocked": "Wallet password verification is required before viewing the card number, expiry date, and CVV.",
    "sensitiveInfoLockedDesc": "For account safety, sensitive card information stays hidden until verification succeeds.",
    "unlockNow": "Verify and Unlock",
    "myCard": "Kartu saya",
    "basicInfo": "Info kartu",
    "cardType": "Jenis kartu",
    "cardholder": "Pemegang kartu",
    "phoneNumberLabel": "Nomor Telepon",
    "validThru": "Valid Thru (MM/YY)",
    "validThroughLabel": "Berlaku hingga",
    "cvvCode": "CVV",
    "openSecurePage": "Open secure page in new window",
    "openVerificationPage": "Open verification page",
    "checkVerificationStatus": "Check verification status",
    "verificationPageUnavailable": "Verification page is unavailable for now. Please check the status later.",
    "diditSdkTitle": "Didit Face Verification",
    "sdkIdle": "Not started",
    "sdkLoading": "Loading verification",
    "sdkReady": "Verification in progress",
    "sdkUnavailable": "Failed to load Didit SDK. Open it externally instead.",
    "sdkCancelled": "KYC verification was cancelled",
    "sdkDeclined": "KYC verification was declined",
    "restartVerification": "Restart verification",
    "sdkCurrentStep": "Current Step",
    "sdkLastEvent": "Last Event",
    "sdkStepDocumentSelection": "Select document type",
    "sdkStepDocumentFront": "Capture document front",
    "sdkStepDocumentBack": "Capture document back",
    "sdkStepFace": "Face verification",
    "sdkStepEmail": "Email verification",
    "cameraPermissionTitle": "Enable Camera Permission",
    "cameraPermissionTip": "Document capture and face verification require browser camera access. Please grant camera permission first.",
    "cameraPermissionDenied": "Camera permission is not available right now. Please allow camera access in your browser settings before continuing.",
    "cameraPermissionGranted": "Camera permission is ready. You can continue with document capture and face verification.",
    "cameraPermissionGrantedToast": "Camera permission enabled",
    "cameraPermissionOpen": "Enable",
    "cameraPermissionReady": "Enabled",
    "cameraPermissionDialog": "Browser camera permission is currently unavailable. Please allow camera access from the browser address bar or system settings, then continue with KYC verification.",
    "sdkStepPhone": "Phone verification",
    "sdkStepPoa": "Proof of address",
    "sdkStepQuestionnaire": "Questionnaire",
    "sdkEventReady": "Verification page ready",
    "sdkEventStarted": "Verification started",
    "sdkEventStepStarted": "Step started",
    "sdkEventStepCompleted": "Step completed",
    "sdkEventStepChanged": "Step changed",
    "sdkEventMediaStarted": "Capture started",
    "sdkEventMediaCaptured": "Capture completed",
    "sdkEventDocumentSelected": "Document selected",
    "sdkEventSubmitted": "Verification submitted",
    "sdkEventCodeSent": "Code sent",
    "sdkEventCodeVerified": "Code verified",
    "sdkEventStatusUpdated": "Status updated",
    "sdkEventCompleted": "Verification completed",
    "sdkEventCancelled": "Verification cancelled",
    "sdkEventError": "Verification error",
    "sdkEventCloseRequest": "Close requested",
    "kycTokenEmpty": "KYC token is empty. Please try again later.",
    "viewAtmPassword": "Lihat PIN ATM",
    "enterAtmPassword": "Enter 6-digit ATM PIN",
    "confirmAtmPassword": "Konfirmasi PIN ATM",
    "atmPasswordTip": "*Kata sandi ini hanya bisa diatur sekali dan bisa dilihat nanti.",
    "sixDigitPin": "Enter a 6-digit numeric PIN",
    "setPinSuccess": "Kata sandi berhasil diatur",
    "GoOpenCard": "Buka Kartu"
  },
  "mine": {
    "title": "Akun Saya",
    "mineCode": "QR Code Saya",
    "scanAddFriend": "Scan to add as WinPay Wallet friend",
    "wallet": "Kelola Dompet",
    "cardCodeRedemption": "Tukarkan Kode Kartu",
    "enterCardCode": "Masukkan Kode Kartu",
    "security": "Pengaturan keamanan",
    "language": "Ganti Bahasa",
    "selectLanguage": "Bahasa",
    "contactUs": "Hubungi kami",
    "about": "Tentang Kami",
    "kyc": "Verifikasi KYC",
    "userId": "User ID",
    "login": "Login/Register",
    "logout": "Keluar dari Akun",
    "logoutConfirm": "Log out of the current account?",
    "logoutConfirmTitle": "Konfirmasi Keluar?",
    "logoutConfirmAccount": "Yakin ingin keluar dari akun saat ini [{name}]?",
    "points": "Poin",
    "currentLevel": "Level Saat Ini",
    "totalPoints": "Total Poin",
    "nextLevelPoints": "{points} points to the next level",
    "levelSurpassed": "Current level exceeded",
    "maxLevelReached": "Maximum level reached",
    "exclusiveLevel": "Level Eksklusif",
    "dailyCheckInPoints": "Check-in harian dapat poin",
    "rewardDetails": "Rincian Hadiah",
    "signIn": "Check-in",
    "signedIn": "Sudah Check-in",
    "checkInSuccess": "Check-in successful, earned {reward} points",
    "gameZone": "Zona Game",
    "gameDesc": "Dapatkan Poin dengan Mudah",
    "shopZone": "Zona E-commerce",
    "shopDesc": "Buat pesanan untuk mendapatkan poin",
    "enterZone": "Enter",
    "inviteFriends": "Undang",
    "inviteDesc": "Invite friends to WinPay",
    "invitedUsers": "Invited registered wallets",
    "recommender": "Inviter",
    "bindSuccess": "Berhasil ditautkan",
    "takePhoto": "Ambil Foto",
    "chooseFromAlbum": "Choose from Library",
    "avatarUpdated": "Avatar updated",
    "avatarUploadFailed": "Avatar upload failed. Please try again later.",
    "avatarImageOnly": "Please choose an image file",
    "avatarImageTooLarge": "Image size must be under {size}MB",
    "changeWalletName": "Rename Wallet",
    "enterWalletName": "Isi Nama Dompet",
    "nameTooLong": "Name cannot exceed 16 characters",
    "nameUpdated": "Name updated",
    "securityTodo": "Security settings migration in progress",
    "kycTodo": "Verifikasi Sekarang",
    "kycPending": "Pending",
    "kycVerified": "Terverifikasi",
    "kycFailed": "Gagal",
    "kycTodoDesc": "Selesaikan verifikasi KYC sebelum melanjutkan fitur kartu virtual atau fisik.",
    "kycPendingDesc": "Your verification materials have been submitted and are under review.",
    "kycVerifiedDesc": "Verifikasi KYC selesai dan verifikasi terkait kartu tersedia untuk akun ini.",
    "kycFailedDesc": "Verification was not approved. Please review the reason and submit again.",
    "viewKycResult": "View Result",
    "retryKyc": "Retry Verification",
    "aboutDesc": "One-stop Web3 social and payment wallet",
    "version": "Version",
    "contactDesc": "If you have any questions, such as wallet deletion or usage issues, please contact us through the following methods:",
    "supportEmail": "Email Layanan Pelanggan",
    "onlineSupport": "Layanan Pelanggan Online",
    "serviceMailbox": "Customer Service Mailbox",
    "serviceHours": "Support Hours",
    "weekdayHours": "Working Days: 09:00 AM - 06:00 PM",
    "supportReplyTip": "Kami akan membalas saat jam layanan.",
    "supportThanks": "Thank you for your support and understanding."
  },
  "article": {
    "square": "Persegi",
    "followTab": "Mengikuti",
    "likeTab": "Koleksi",
    "nowTab": "News",
    "create": "Publikasikan",
    "myArticle": "My Articles",
    "detail": "Article Detail",
    "addToken": "Tambah Token",
    "addNft": "Tambahkan NFT",
    "reportTitle": "Laporkan",
    "reportSuccess": "Thanks for your feedback.",
    "reportFailed": "Submit failed. Coba lagi nanti.",
    "reasonAttack": "Ofensif dan provokatif",
    "reasonPorn": "Pornografi dan vulgar",
    "reasonDiscomfort": "Tidak nyaman",
    "reasonSpam": "Iklan spam",
    "follow": "ikuti",
    "followed": "Sudah diikuti",
    "followSuccess": "Sudah diikuti",
    "unfollowSuccess": "Pelacakan dibatalkan",
    "likeSuccess": "Liked",
    "unlikeSuccess": "Unliked",
    "now": "Hanya",
    "minutesAgo": "Menit yang lalu",
    "hoursAgo": "Beberapa jam yang lalu",
    "daysAgo": "Beberapa hari yang lalu",
    "views": "Views",
    "forwarded": "Relay",
    "empty": "No content",
    "searchPlaceholder": "Cari",
    "unsupportedNetwork": "The current network does not support home content.",
    "switchNetwork": "Ganti jaringan",
    "observerWalletWarn": "Watch-only wallets cannot access home content.",
    "switchWallet": "Switch Wallet",
    "openDetailTodo": "Article detail is pending migration",
    "createTodo": "Article publishing is pending migration",
    "addTokenTodo": "Add token is pending migration",
    "addNftTodo": "Add NFT is pending migration",
    "sampleName": "WinPay User",
    "sampleTopic": "Flutter article module migration preview",
    "sampleContent": "This page carries the migrated H5 styles, state, and sheet interaction for article modules."
  }
};
